/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_1_AnswerInputs */

const en_svc_integration_faq_1_answer = /** @type {(inputs: Svc_Integration_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything with an API or a reliable export: CRMs such as HubSpot, Gmail and Microsoft 365, Slack, Google Workspace, accounting and ERP systems, databases and your own applications. We confirm access during discovery.`)
};

const lv_svc_integration_faq_1_answer = /** @type {(inputs: Svc_Integration_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar jebko, kam ir API vai uzticams eksports: CRM, piemēram, HubSpot, Gmail un Microsoft 365, Slack, Google Workspace, grāmatvedības un ERP sistēmām, datubāzēm un Jūsu pašu lietotnēm. Piekļuvi pārbaudām izpētes laikā.`)
};

/**
* | output |
* | --- |
* | "Anything with an API or a reliable export: CRMs such as HubSpot, Gmail and Microsoft 365, Slack, Google Workspace, accounting and ERP systems, databases and ..." |
*
* @param {Svc_Integration_Faq_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_1_answer = /** @type {((inputs?: Svc_Integration_Faq_1_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_1_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_1_answer(inputs)
	return en_svc_integration_faq_1_answer(inputs)
});